import React from 'react';

import EmptyChat from '../../../../../assets/svgComponents/EmptyChat';
import IncomingMsgShimmerComponent from './incomingMsgShimmerComponent';
import OutgoingMsgShimmerComponent from './outgoingMsgShimmerComponent';
import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './chatContainerShimmerComponent.css';

const ChatContainerShimmerComponent = ({showShimmer = true}) => {
  return showShimmer ? (
    <div className="et-v2-chat-container-shimmer-container">
      <div className="et-v2-ccs-header-wrap">
        <div className="et-v2-ccs-mentor-pill-wrap">
          <ShimmerComponent />
        </div>
        <div className="et-v2-edit-mentor-name">
          <div className="et-v2-ccs-title-wrap">
            <ShimmerComponent />
          </div>
          <div className="et-v2-ccs-title-wrap">
            <ShimmerComponent />
          </div>
        </div>
        <div className="et-v2-ccs-download-icon">
          <ShimmerComponent />
        </div>
      </div>

      <div className="et-v2-ccs-center-content-wrap">
        <IncomingMsgShimmerComponent />
        <OutgoingMsgShimmerComponent />
        <IncomingMsgShimmerComponent />
      </div>

      <div className="et-v2-ccs-footer-wrap">
        <div className="et-v2-ccs-footer-option-tabs-wrap">
          {Array.from({length: 5}).map((val, idx) => (
            <div key={idx} className="et-v2-ccs-footer-option-tab">
              <ShimmerComponent />
            </div>
          ))}
        </div>
        <div className="et-v2-ccs-footer-search-bar">
          <ShimmerComponent />
        </div>
      </div>
    </div>
  ) : (
    <div className="et-v2-ccs-empty-chat-container-wrap">
      <EmptyChat />
    </div>
  );
};

export default ChatContainerShimmerComponent;
